/**
 * Manage, Groups (plan docs/plans/lms-plan.md 8.2, 5.3, 18.20, 18.21; plan
 * section 13 tab 7; WP-43; R6, R19).
 *
 * Replaces WP-03's placeholder in place: tabs/manage/subviews.ts imports this
 * file's DEFAULT export (a component with no props), mounted under the Manage
 * tab's PageHeader and SegmentedTabs at /lms/manage/groups/* (plan 18.3), so
 * it routes its own deeper paths:
 *
 *   /lms/manage/groups             the list (GroupList)
 *   /lms/manage/groups/:groupId    one group, its members and, for a profile,
 *                                  its required courses (GroupDetailPage)
 *
 * Requirement profiles assign their courses to their members on their own
 * (the reconcile runs after every change, 8.2); saved audiences are lists of
 * people the Assign wizard sends to (R6).
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import GroupDetailPage from './GroupDetailPage';
import GroupList from './GroupList';
import { GROUPS_BASE } from './reconcile';

export function GroupsView() {
  return (
    <Routes>
      <Route index element={<GroupList />} />
      <Route path=":groupId" element={<GroupDetailPage />} />
      <Route path="*" element={<Navigate to={GROUPS_BASE} replace />} />
    </Routes>
  );
}

export default GroupsView;
